import React, { PropsWithChildren } from 'react'
import { toast } from 'react-toastify'
import { Me } from 'service/user'
import { ReactComponent as CopyIcon } from 'svg/copy.svg'
import { ReactComponent as ExternalIcon } from 'svg/fi_external-link.svg'
import { ReactComponent as HelpIcon } from 'svg/fi_help-circle.svg'
import { UserType } from 'utils/common'

interface FastclickDescriptionProps {
  userInfo: Me
}

export const FastclickDescription = ({
  userInfo,
}: PropsWithChildren<FastclickDescriptionProps>) => {
  const moveToUrl = (url: string) => {
    if (url) {
      window.open(url)
    }
  }

  const handleCopyClipBoard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text)
      toast.success('copy 완료', {
        position: 'bottom-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })
    } catch (e) {}
  }
  return (
    <>
      {' '}
      <div className=" bg-gradient-to-r from-[#FF1E5E] to-[#FF8A00] md:p-8 p-4 flex flex-col md:rounded-[40px] gap-2">
        <div>
          <p className="flex gap-2 items-center">
            <span>
              <img src="assets/img/logo/fastclick_white.png" alt="fastclick" />
            </span>
            <span className="text-white font-[900] ">FASTCLICK</span>
            <span className="text-white font-bold  text-[14px] ">
              for 상품 숏폼
            </span>
          </p>
          <p className=" font-bold text-white mt-2">패스트클릭이란?</p>
          <p className="text-white">
            상품 숏폼 영상에서 상품 구매 링크를 직접 제공하기 위해
            <br /> 패스트컷 AI가 자체 제공하는{' '}
            <span className="font-bold">“링크 서비스”</span>입니다.
            <br /> 상품 숏폼을 생성하면 패스트클릭에 상품 구매 링크 블록이 자동
            생성됩니다.
            <br />
            유튜브 프로필에 나의 패스트클릭 페이지 주소를 세팅해두고, 숏폼
            댓글에 링크를 안내하세요!
          </p>
        </div>
        <div className="flex flex-col gap-2">
          <div className="flex flex-col rounded-[10px] bg-white px-4 py-3 ">
            <p className="font-bold text-[14px]">
              나의 패스트클릭 페이지 주소{' '}
              <a
                href={userInfo?.fastClickLink?.fastClickLink}
                target="_blank"
                rel="noreferrer"
                className="text-href text-[14px]"
              >
                {userInfo?.fastClickLink?.fastClickLink}
              </a>
            </p>
            <p
              className="  flex  w-full font-bold cursor-pointer text-[14px] gap-2"
              onClick={() => {
                moveToUrl(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <span>나의 링크 블록 확인하러 가기</span>
              <span className="text-[#FF8800]">
                {' '}
                {userInfo?.userType !== UserType.USER
                  ? userInfo?.fastClickLink?.productCount.toLocaleString() ?? 0
                  : 0}
                개 {`>`}
              </span>
            </p>
          </div>
          <div className="grid md:grid-cols-4 grid-cols-1 gap-y-2 gap-x-1">
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl('https://youtu.be/vWvoVyGzcDs?si=CEQWeWr_fM3yUmxl')
              }}
            >
              <HelpIcon />
              1분 완벽 이해 유튜브
              <img src="assets/img/logo/youtube.png" alt="youtube" width={26} />
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl('https://blog.fastseller.shop/fastclick_guide/')
              }}
            >
              <HelpIcon />
              차근차근 블로그 안내
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                moveToUrl(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <ExternalIcon stroke="red" /> 페이지 방문
            </button>
            <button
              className="bg-[rgba(165,0,11,0.3)] text-white font-bold text-[14px] flex justify-center items-center h-[40px] rounded-[10px] gap-1"
              onClick={() => {
                handleCopyClipBoard(userInfo?.fastClickLink?.fastClickLink)
              }}
            >
              <CopyIcon className="text-white" />
              주소 복사
            </button>
          </div>
          <div className="bg-[#2E343D] p-2 rounded-[10px]">
            <ul className=" list-disc text-white text-[14px] ml-4">
              <li>
                나의 패스트클릭 페이지 주소를 쿠팡파트너스나 알리 어필리에이트에
                등록한 후 사용해주세요
              </li>
              <li>
                패스트클릭은 패스트컷 AI 상품 영상 플랜 유지기간동안 사용
                가능합니다. (플랜 종료시 함께 사용종료)
              </li>
              <li>
                플랜 종료 1개월 이내에 재결제시, 기존에 사용했던 패스트클릭 링크
                블록을 복구할 수 있습니다.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  )
}
